export default __webpack_public_path__ + "static/media/logo1.e1111d03.png";